<template>
  <div class="profile-education">
    <gray-block v-if="education.length === 0">
      <h4 class="disabled">Нет информации</h4>
      <br /><br />
    </gray-block>

    <div class="education-items">
      <template v-for="(item, index) in education" :key="`education-${index}`">
        <education-item :item="item" />
      </template>
    </div>
  </div>
</template>

<script setup>
import {useApi} from "@/api/use-api";
import {onMounted, ref, watch} from "vue";
import { useStore } from 'vuex';
import EducationItem from "@/components/profile/education/EducationItem.vue";
import GrayBlock from "@/components/blocks/GrayBlock.vue";

const api = useApi();
const store = useStore();
const education = ref([]);

const getEducation = async () => {
  if (!store.state.person.id) return;

  try {
    let response = await api.education.index(
      new URLSearchParams({
        personId: store.state.person.id,
      })
    );

    education.value = response.education.map((item, index) => ({
      ...item,
      index: index,
    }));

  } catch (error) {
    // TODO: добавить обработку ошибок
    console.log(error);
  }
};

onMounted(() => {
  getEducation();
});

watch(
    () => store.state.person.id,
    () => {
      getEducation();
    }
);
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .profile-education {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    h4.disabled {
      color: $color-text-secondary-grey;
    }

    .education-items {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
</style>
